<script setup lang="ts">
import { defineProps, ref } from 'vue';

import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';

defineProps<{
  error?: string | undefined;
}>();

const type = ref<'password' | 'text'>('password');

function toggleType() {
  if (type.value === 'password') {
    type.value = 'text';

    return;
  }

  type.value = 'password';
}
</script>

<template>
  <label class="block text-left" :class="$attrs.class">
    <slot></slot>

    <IconField v-bind="$attrs" class="mt-1 block w-full" :invalid="!!error">
      <InputText class="w-full" v-bind="$attrs" size="small" :type="type" />

      <InputIcon
        class="cursor-pointer"
        :class="{
          'pi pi-eye-slash': type === 'password',
          'pi pi-eye': type === 'text',
        }"
        @click="toggleType"
      />
    </IconField>

    <small class="mt-1 text-left text-xs text-red-600">
      {{ error }}
    </small>
  </label>
</template>
